import DefaultSidebar from '../../components/Sidebar/';
import {connect} from 'react-redux';
import nav from './_nav';

class MainSidebar extends DefaultSidebar {
  render() {
    return (
      this.renderDefault(nav.items)
    )
  }
}

const mapStateToProps = (state) => ({ state: state });

export default connect(mapStateToProps)(MainSidebar);



// WEBPACK FOOTER //
// ./src/views/MainSidebar/MainSidebar.js